(() => {
  const toggleSubscriptionWidget = (form, variant) => {
    if (!form || !variant) return;

    const hasPlans = (variant.selling_plan_allocations || []).length > 0;
    form.classList.toggle('rc-no-plans', !hasPlans);

    if (!hasPlans) {
      const onetime = form.querySelector('input[data-radio-onetime]');
      if (onetime && !onetime.checked) onetime.click();
    }
  };

  document.addEventListener('variant:change', (event) => {
    toggleSubscriptionWidget(event.target, event.detail?.variant);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('variant-picker[form-id]').forEach((picker) => {
      const data = picker.querySelector('script[data-variant]');
      if (!data) return;
      try {
        toggleSubscriptionWidget(document.forms[picker.getAttribute('form-id')], JSON.parse(data.textContent));
      } catch (e) {}
    });
  });
})();
